import { createRouter, createWebHistory } from 'vue-router'
import WorkbenchLayout from '@/layouts/WorkbenchLayout.vue'

import LandingView from '@/views/LandingView.vue'
import UsageGuideView from '@/views/UsageGuideView.vue'
import EnterpriseServicesView from '@/views/EnterpriseServicesView.vue'

import UploadView from '@/views/UploadView.vue'
import ImageGenView from '@/views/ImageGenView.vue'
import CopywritingView from '@/views/CopywritingView.vue'
import SizeChartView from '../views/SizeChartView.vue'
import PromoVideoView from '@/views/PromoVideoView.vue'
import AccountView from '@/views/AccountView.vue'
import PaymentView from '@/views/PaymentView.vue'
import LoginView from '@/views/LoginView.vue'

const routes = [
  {
    path: '/home',
    name: 'home',
    component: LandingView,
    meta: { title: '智磐 AI - 跨境电商素材工厂' }
  },
  {
    path: '/home/usage',
    name: 'home-usage',
    component: UsageGuideView,
    meta: { title: '使用说明 - 智磐 AI' }
  },
  {
    path: '/home/services',
    name: 'home-services',
    component: EnterpriseServicesView,
    meta: { title: '企业服务 - 川岳智磐' }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: WorkbenchLayout,
    children: [
      { path: '', redirect: '/home' },

      {
        path: '/upload',
        name: 'upload',
        component: UploadView,
        meta: {
          navKey: 'upload',
          breadcrumb: '产品上传',
          title: '产品上传',
          subTitle: '上传产品参考图'
        }
      },
      {
        path: '/image-gen',
        name: 'imageGen',
        component: ImageGenView,
        meta: {
          navKey: 'imageGen',
          breadcrumb: '图片生成',
          title: '图片生成',
          subTitle: 'AI 智能生成宣传图与裂变'
        }
      },
      {
        path: '/copywriting',
        name: 'copywriting',
        component: CopywritingView,
        meta: {
          navKey: 'copywriting',
          breadcrumb: '文案生成',
          title: '文案生成',
          subTitle: 'Amazon Listing 文案'
        }
      },
      {
        path: '/size-chart',
        name: 'size-chart',
        component: SizeChartView,
        meta: {
          navKey: 'sizeChart',
          breadcrumb: '尺码转换',
          title: '尺码转换',
          subTitle: 'AI 中英尺码转换与图片重绘'
        }
      },
      {
        path: '/promo-video',
        name: 'promo-video',
        component: PromoVideoView,
        meta: {
          navKey: 'promoVideo',
          breadcrumb: '宣传视频生成',
          title: '宣传视频生成',
          subTitle: '选择宣传图，生成宣传视频'
        }
      },
      {
        path: '/account',
        name: 'account',
        component: AccountView,
        meta: {
          navKey: 'account',
          breadcrumb: '账号管理',
          title: '账号管理',
          subTitle: '账户基础信息与安全快捷入口'
        }
      },
      {
        path: '/payment',
        name: 'payment',
        component: PaymentView,
        meta: {
          navKey: 'account',
          breadcrumb: '算力充值',
          title: '算力充值',
          subTitle: '选择套餐，扫码支付'
        }
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
